import { useTranslation } from 'react-i18next';
import { MonthEnum } from '../../../../../enums/monthEnum';
import { useMemo } from 'react';
import {ATTENDANCE_MODES} from "../../../Dining/Manage/Models/Model";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const GetDateFilter = (props) => {
    const { t } = useTranslation();

    // Function to get the dates for fortnightAndDate
    const getCurrentFortnightAndDate = () => {
        const today = new Date();
        const dayOfMonth = today.getDate();
        const monthIndex = today.getMonth() + 1;
        const biweekly = dayOfMonth <= 15 ? '1°' : '2°';
        const monthName = MonthEnum[monthIndex];
        const translatedMonthName = t(monthName);
        const startOfFortnight =
            dayOfMonth <= 15
                ? new Date(today.getFullYear(), today.getMonth(), 1)
                : new Date(today.getFullYear(), today.getMonth(), 16);

        const endOfFortnight =
            dayOfMonth <= 15
                ? new Date(today.getFullYear(), today.getMonth(), 15)
                : new Date(today.getFullYear(), today.getMonth() + 1, 0);

        return {
            biweekly,
            startOfFortnight,
            endOfFortnight,
            translatedMonthName,
            start: startOfFortnight.getTime(),
            end: endOfFortnight.getTime()
        };
    };

    // To avoid inecessary calculations
    const currentFortnightData = useMemo(() => getCurrentFortnightAndDate(), []);

    const getCurrentWeekOfYearWithWeekdays = () => {
        const today = new Date();

        // Get Monday of current week
        const day = today.getDay();
        const diff = today.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is Sunday
        const startOfWeek = new Date(today.setDate(diff));
        startOfWeek.setHours(0, 0, 0, 0);

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);
        endOfWeek.setHours(23, 59, 59, 999);

        // Calculate ISO week number
        const getWeekNumber = (date) => {
            const temp = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
            const dayNum = temp.getUTCDay() || 7;
            temp.setUTCDate(temp.getUTCDate() + 4 - dayNum);
            const yearStart = new Date(Date.UTC(temp.getUTCFullYear(), 0, 1));
            return Math.ceil((((temp - yearStart) / 86400000) + 1) / 7);
        };

        const weekOfYear = getWeekNumber(today);

        return {
            weekOfYear,
            startOfWeek: startOfWeek,
            endOfWeek: endOfWeek,
            start: startOfWeek.getTime(),
            end: endOfWeek.getTime()
        };
    };

    // To avoid inecessary calculations
    const currentWeekOfYearWithWeekdays = useMemo(() => getCurrentWeekOfYearWithWeekdays(), []);

    //funtion to get current month dates
    const getCurrentMonthDates = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth(); // 0-based

        const monthName = MonthEnum[month + 1];

        const firstDay = new Date(year, month, 1); // 1st day of current month
        const lastDay = new Date(year, month + 1, 0, 23, 59, 59, 999); // last day of current month

        return {
            monthName,
            firstDay: firstDay,
            lastDay:lastDay,
            start: firstDay.getTime(),
            end: lastDay.getTime()
        };
    };

    const currentMonthDates = useMemo(() => getCurrentMonthDates(), []);


    const getAttendanceDate = (selectedOption) => {
        let start;
        let end;
        const date = new Date();

        switch (selectedOption){
            case ATTENDANCE_MODES.weekly:
                start = currentWeekOfYearWithWeekdays.start;
                end = currentWeekOfYearWithWeekdays.end;
                break;
            case ATTENDANCE_MODES.biweekly:
                start = currentFortnightData.start;
                end = currentFortnightData.end;
                break;
            case ATTENDANCE_MODES.monthly:
                start = currentMonthDates.start;
                end = currentMonthDates.end;
                break;
            default:
                start = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0).getTime();
                end   = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999).getTime();
                break;
        };

        return {
            start,
            end
        }
    }
    return {
        currentFortnightData,
        currentWeekOfYearWithWeekdays,
        currentMonthDates,
        getAttendanceDate
    };
};

export default GetDateFilter;
